import { IconCLI, IconJSLanguage, IconPythonLanguage } from 'components/Icons';
import { Language, ModelLanguage } from 'modules/EntityReference/CodeSnippets';

export const CodeByLang = {
  bash: `# Install Clarifai
SDK pip install -U clarifai`,
  python: `from clarifai.client import create_client

# Initialize the Clarifai client
client = create_client()

# Set your Personal Access Token (PAT)
client.set_personal_access_token("your_personal_access_token")  `,
  pythonSDK: ({ modelName = 'modelName' }: { modelName: string }) => `# Select the LLaMA model and provide input
model = client.models.get("${modelName}")
response = model.predict_by_text("What is the meaning of life?")

# Print the response
print(response)`,
};

export const LanguageMappping = {
  [ModelLanguage.Python]: { fileName: 'index.py', value: 'python' },
  [ModelLanguage.PythonSDK]: { fileName: 'index.py', value: 'python' },
  [ModelLanguage.PythonOpenAI]: { fileName: 'index.py', value: 'python' },
  [ModelLanguage.PythonMCP]: { fileName: 'index.py', value: 'python' },
  [ModelLanguage.NodeJS]: { fileName: 'index.js', value: 'javascript' },
  [ModelLanguage.NodeJS_SDK]: { fileName: 'index.js', value: 'javascript' },
  [ModelLanguage.NodeJSOpenAI]: { fileName: 'index.js', value: 'javascript' },
  [ModelLanguage.NodeJSVercel]: { fileName: 'index.js', value: 'javascript' },
  [ModelLanguage.Javascript]: { fileName: 'index.js', value: 'javascript' },
  [ModelLanguage.Java]: { fileName: 'Output.java', value: 'java' },
  [ModelLanguage.cURL]: { fileName: 'index.sh', value: 'bash' },
  [ModelLanguage.PHP]: { fileName: 'index.php', value: 'php' },
};

export const LanguageDropdownOptions = [
  { value: Language.PythonSDK, label: Language.PythonSDK, icon: IconPythonLanguage },
  { value: Language.NodeJS_SDK, label: Language.NodeJS_SDK, icon: IconJSLanguage },
  { value: Language.Javascript, label: Language.Javascript, icon: IconCLI },
  { value: Language.Python, label: Language.Python, icon: IconCLI },
  { value: Language.Java, label: Language.Java, icon: IconCLI },
  { value: Language.cURL, label: Language.cURL, icon: IconCLI },
  { value: Language.PHP, label: Language.PHP, icon: IconCLI },
];

export const SDKOptions = [
  { value: Language.PythonSDK, label: Language.PythonSDK, icon: IconPythonLanguage },
  { value: Language.NodeJS_SDK, label: Language.NodeJS_SDK, icon: IconJSLanguage },
  // { value: 'CLI', label: 'CLI (Command-line interface)', icon: IconCLI },
  { value: Language.Java, label: Language.Java, icon: IconCLI },
  { value: Language.PHP, label: Language.PHP, icon: IconCLI },
];
